import { render, staticRenderFns } from "./CompanyLogoItems.vue?vue&type=template&id=12061fc9&scoped=true&"
import script from "./CompanyLogoItems.vue?vue&type=script&lang=js&"
export * from "./CompanyLogoItems.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLogoItems.vue?vue&type=style&index=0&id=12061fc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12061fc9",
  null
  
)

export default component.exports